import React from "react";
import {LocalizationContext} from "./localizationContext";
import {LocalizationProviderProps, Locale, CleanedLocale} from "./types";
import {makeLocalize} from "./localize";
import {makeFormatCurrency} from "./formatCurrency";

const cleanLocale = (locale: Locale): Locale =>
  locale.replace("_", "-") as Locale;

export function LocalizationProvider({
  translations,
  locale,
  children,
}: LocalizationProviderProps): JSX.Element {
  const cleanedLocale = cleanLocale(locale) as CleanedLocale;
  const translationsForLocale = translations[cleanedLocale]?.translation ?? {};
  const localize = makeLocalize(translationsForLocale, cleanedLocale);
  const formatCurrency = makeFormatCurrency(cleanedLocale);
  return (
    <LocalizationContext.Provider
      value={{
        locale: cleanedLocale,
        translations: translationsForLocale,
        localize,
        formatCurrency,
      }}
    >
      {children}
    </LocalizationContext.Provider>
  );
}
